import { ProductSlugs } from 'Src/constants/ProductSlugs'

export enum ProductDirection {
	ONLINE = 'Онлайн',
	OFFLINE = 'Офлайн',
	ONLINE_MANAGER = 'Без визита в банк (менеджер банка)',
	REJECT_ONLINE = 'Отклоненный онлайн',
	DELAYED_ONLINE = 'Ожидание онлайн',
}

export const ProductDirectionVbv = [
	ProductDirection.ONLINE,
	ProductDirection.ONLINE_MANAGER,
	ProductDirection.REJECT_ONLINE,
	ProductDirection.DELAYED_ONLINE,
]

export const INTEGRATED_PRODUCTS: ProductSlugs[] = [
	ProductSlugs.INSALES,
	ProductSlugs.DOCDOC,
	ProductSlugs.PARTNER_VERIFICATION_SERVICE,
	ProductSlugs.SBEREGI_BIZNES,
	ProductSlugs.DOUBLE_GIS,
	// ProductSlugs.MOYA_BUHGALTERIYA_AUTSORSING,
]

export const PRODUCTS_RESEND_SMS: ProductSlugs[] = [
	ProductSlugs.NAVIGATOR_MSP,
	ProductSlugs.PREMIUM_DS,
]

export const PRODUCTS_RESEND_EMAIL: ProductSlugs[] = [ProductSlugs.PREMIUM_DS]

export const CabinetProCheckboxOffProducts = [
	ProductSlugs.TORGOVYY_EKVAYRING,
	ProductSlugs.SMART_TERMINAL,
	ProductSlugs.ZARPLATNYY_PROEKT,
	ProductSlugs.MOBILNYY_KASSIR,
]
